export function to12HourClock(time) {
  if (!time.match(/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/)) {
    console.error("please pass a valid 24 hour time");
    return time;
  }
  // this initial value covers noon
  let result = `${time.replace(":00", "")}pm`;
  const [hours, minutes] = time.split(":");
  // 1. Starting from the first hour of the day (0:00 / midnight to 0:59), add 12 hours and AM to the time.
  if (hours === "00") {
    result = "12";
    if (minutes !== "00") {
      result += `:${minutes}`;
    }
    result += "am";
  }
  // 2. From 1:00 to 11:59, simply add AM to the time.
  if (hours >= "01" && hours <= "11") {
    result = `${time.replace(":00", "")}am`;
  }
  // 3. For times between 13:00 to 23:59, subtract 12 hours and add PM to the time.
  if (hours >= "13" && hours <= "23") {
    result = parseInt(hours, 10) - 12;
    if (minutes !== "00") {
      result += `:${minutes}`;
    }
    result += "pm";
  }

  return result;
}
